import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiBox, FiAlertTriangle, FiXCircle, FiBookmark, FiTruck, FiClipboard, FiTool } from 'react-icons/fi';
import { api } from '../api';

export default function InventoryOverview() {
  const nav = useNavigate();
  const [c, setC] = useState(null);
  const [toast, setToast] = useState('');
  const [notif, setNotif] = useState(null);
  const [listModal, setListModal] = useState(null);
  useEffect(() => { api('/replenishment/overview/cards').then(setC).catch((e) => setToast(e.message)); }, []);
  useEffect(() => { api('/tasks/inventory-notifications').then(setNotif).catch(() => {}); }, []);

  const cards = c ? [
    { label: 'Products', value: c.products, icon: <FiBox />, color: '#2C5F8A', to: '/m/store' },
    { label: 'Low stock', value: c.low_stock, icon: <FiAlertTriangle />, color: '#A87B2D', to: '/m/store' },
    { label: 'Out of stock', value: c.out_of_stock, icon: <FiXCircle />, color: '#B4432E', to: '/m/store' },
    { label: 'With reservations', value: c.with_reservations, icon: <FiBookmark />, color: '#3E7C6B', to: '/m/store' },
    { label: 'Damaged stock', value: c.damaged_units, icon: <FiAlertTriangle />, color: '#B4432E', to: '/m/store' },
    { label: 'To order', value: c.to_order, icon: <FiTruck />, color: '#B08D57', to: '/m/replenishment' },
    { label: 'Purchase requests pending', value: c.purchase_pending, icon: <FiTruck />, color: '#3A6A96', to: '/m/purchase_requests' },
    { label: 'Requirements open', value: c.requirements_open, icon: <FiClipboard />, color: '#5A6472', to: '/m/requirements' },
    { label: 'Assemblies in progress', value: c.assemblies_open, icon: <FiTool />, color: '#875A7B', to: '/m/assembly' },
  ] : [];
  const notifCards = notif ? [
    { label: 'Campaign procurement', value: notif.procurement_count, icon: <FiTruck />, color: '#3A6A96', items: notif.procurement, kind: 'procurement' },
    { label: 'Campaign assembly', value: notif.assembly_count, icon: <FiTool />, color: '#875A7B', items: notif.assembly, kind: 'assembly' },
  ] : [];

  return (
    <div>
      <div className="mod-head">
        <div className="titles">
          <div className="page-eyebrow">Inventory</div>
          <h1>Overview</h1>
          <div className="count">{c ? 'Live inventory summary' : 'Loading…'}</div>
        </div>
      </div>

      {!c ? <div className="empty">{toast || 'Loading…'}</div> : (
        <div className="inv-cards">
          {cards.map((card) => (
            <button key={card.label} className="inv-card" onClick={() => nav(card.to)}>
              <div className="inv-card-top">
                <span className="inv-card-ic" style={{ background: card.color + '18', color: card.color }}>{card.icon}</span>
                <span className="inv-card-val" style={{ color: card.value > 0 && (card.label.includes('Low') || card.label.includes('Out') || card.label.includes('To order') || card.label.includes('Damaged')) ? card.color : '#1E2733' }}>{card.value}</span>
              </div>
              <div className="inv-card-label">{card.label}</div>
            </button>
          ))}
        </div>
      )}

      {notif && (notif.procurement_count > 0 || notif.assembly_count > 0) && (
        <>
          <div className="mod-head" style={{ marginTop: 28 }}>
            <div className="titles"><h1 style={{ fontSize: 18 }}>From Marketing</h1>
              <div className="count">Campaign activities that need the inventory team</div></div>
          </div>
          <div className="inv-cards">
            {notifCards.map((card) => (
              <button key={card.label} className="inv-card" onClick={() => card.value > 0 && setListModal(card)}>
                <div className="inv-card-top">
                  <span className="inv-card-ic" style={{ background: card.color + '18', color: card.color }}>{card.icon}</span>
                  <span className="inv-card-val" style={{ color: card.value > 0 ? card.color : '#1E2733' }}>{card.value}</span>
                </div>
                <div className="inv-card-label">{card.label}</div>
              </button>
            ))}
          </div>
        </>
      )}

      {listModal && <NotifListModal card={listModal} onClose={() => setListModal(null)} />}
      {toast && <div className="toast">{toast}</div>}
    </div>
  );
}


function NotifListModal({ card, onClose }) {
  const nav = useNavigate();
  function overdueTag(r) {
    if (r.days_overdue == null) return null;
    const d = Number(r.days_overdue);
    if (d > 0) return <span className="pill" style={{ background: '#FBEEEA', color: '#B4432E', marginLeft: 8 }}>{d}d late</span>;
    if (d === 0) return <span className="pill" style={{ background: '#FDF3E3', color: '#A87B2D', marginLeft: 8 }}>due today</span>;
    return null;
  }
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 720 }} onClick={(e) => e.stopPropagation()}>
        <h2>{card.label}</h2>
        <p className="page-desc" style={{ margin: '0 0 14px', fontSize: 13 }}>
          {card.kind === 'procurement'
            ? 'Items marketing campaigns need procured. Raise a purchase request for these.'
            : 'Items marketing campaigns need assembled. Create an assembly for these.'}
        </p>
        <div className="table-card" style={{ maxHeight: 360, overflowY: 'auto' }}>
          <table className="data">
            <thead><tr><th>Activity</th><th>Products</th><th>Campaign</th><th>Due</th><th>Owner</th></tr></thead>
            <tbody>
              {card.items.map((r) => (
                <tr key={r.id} style={{ cursor: 'pointer' }} onClick={() => nav('/m/campaigns/' + r.campaign_id)}>
                  <td style={{ fontWeight: 600 }}>{r.title}{overdueTag(r)}</td>
                  <td style={{ fontSize: 12.5 }}>{(r.products || []).length
                    ? r.products.map((p) => `${p.product_name} × ${Number(p.qty).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`).join(', ')
                    : <span style={{ color: '#A87B2D' }}>Not set</span>}</td>
                  <td style={{ color: 'var(--muted)' }}>{r.campaign_name}</td>
                  <td style={{ color: 'var(--muted)' }}>{r.due_date ? r.due_date.slice(0, 10) : '—'}</td>
                  <td style={{ color: 'var(--muted)' }}>{r.assignee_name || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="modal-actions">
          <button className="btn" onClick={onClose}>Close</button>
          <button className="btn btn-dark" onClick={() => nav(card.kind === 'procurement' ? '/m/purchase_requests' : '/m/assembly')}>
            Go to {card.kind === 'procurement' ? 'Purchase Requests' : 'Assembly'}
          </button>
        </div>
      </div>
    </div>
  );
}
